import { Pipe } from '@angular/core';
var IsLessThanPipe = (function () {
    function IsLessThanPipe() {
    }
    IsLessThanPipe.prototype.transform = function (input, other) {
        return input < other;
    };
    return IsLessThanPipe;
}());
export { IsLessThanPipe };
IsLessThanPipe.decorators = [
    { type: Pipe, args: [{ name: 'isLessThan' },] },
];
/** @nocollapse */
IsLessThanPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=is-less-than.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-less-than.js
// module id = 226
// module chunks = 4